module.exports = __webpack_public_path__ + "media/customizations/ontopoftheworld/back-84e44b2e223481aa5cad98f7f711abb3.jpg";